import {
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Grid,
} from "@material-ui/core";
import { CheckCircleOutline, Error, Info, Warning } from "@material-ui/icons";
import RxButton from "../RxButton";
import RxTypography from "../RxTypography";
import styles from "./RxDialog.module.css";

interface RxDialogProp {
	title: string;
	children?: any;
	status?: "warning" | "info" | "error" | "success" | undefined;
	handleClose?: () => void;
	open?: boolean;
	fullWidth?: boolean;
	maxWidth?: false | "xs" | "sm" | "md" | "lg" | "xl";
	fullScreen?: boolean;
	style?: any;
	className?: string;
	actions?: any;
	firstButtonLabel?: string;
	firstButtonAction?: () => void;
	firstButtonColor?: "inherit" | "default" | "primary" | "secondary";
	secondButtonLabel?: string;
	secondButtonAction?: () => void;
	secondButtonColor?: "inherit" | "default" | "primary" | "secondary";
}

export interface RxDialogState {
	isOpen: boolean;
	title: string;
	status: "warning" | "info" | "error" | "success" | undefined;
	message: string;
}

const RxDialog = (props: RxDialogProp) => {
	const defaultActions = () => {
		return (
			<>
				<Grid container spacing={1}>
					<Grid item xs={6}>
						<RxButton
							fullWidth
							label={props.firstButtonLabel ?? "Tamam"}
							onClick={props.firstButtonAction ?? undefined}
							variant="contained"
							color={props.firstButtonColor ?? "primary"}
						></RxButton>
					</Grid>
					<Grid item xs={6}>
						<RxButton
							fullWidth
							label={props.secondButtonLabel ?? "İptal"}
							onClick={props.secondButtonAction ?? undefined}
							variant="contained"
							color={props.secondButtonColor ?? "secondary"}
						></RxButton>
					</Grid>
				</Grid>
			</>
		);
	};

	function headerIcon() {
		switch (props.status) {
			case "warning":
				return <Warning />;
			case "error":
				return <Error />;
			case "success":
				return <CheckCircleOutline />;
			case "info":
				return <Info />;
			default:
				return <></>;
		}
	}

	function headerClassName() {
		switch (props.status) {
			case "warning":
				return styles.dialogHeaderWarning;
			case "error":
				return styles.dialogHeaderError;
			case "success":
				return styles.dialogHeaderSuccess;
			case "info":
				return styles.dialogHeaderInfo;
			default:
				return "";
		}
	}

	return (
		<>
			<Dialog
				onClose={props.handleClose}
				open={props.open ?? true}
				fullWidth={props.fullWidth}
				fullScreen={props.fullScreen}
				maxWidth={props.maxWidth}
				style={props.style}
				className={props.className}
			>
				<DialogTitle
					className={styles.dialogHeader + " " + headerClassName()}
				>
					<Grid
						container
						alignItems="center"
						direction="row"
						justifyContent="center"
						alignContent="center"
						spacing={0}
					>
						<Grid item container xs={1} justifyContent="center">
							{headerIcon()}
						</Grid>
						<Grid item container xs={11} justifyContent="flex-start">
							<RxTypography
								label={props.title}
								className={styles.dialogTitle}
							/>
						</Grid>
					</Grid>
				</DialogTitle>
				<DialogContent className={styles.dialogContent}>
					{props.children}
				</DialogContent>
				<DialogActions>{props.actions ?? defaultActions()}</DialogActions>
			</Dialog>
		</>
	);
};

export default RxDialog;
